export class ErrorMessage {
  iconName: string;
  title: string;
  text: string;
  buttonText: string;
  route: string;
  hiddenButton: boolean;

  constructor(iconName: string, title: string, text: string, buttonText: string, route: string, hiddenButton?: boolean) {
    this.iconName = iconName;
    this.title = title;
    this.text = text;
    this.buttonText = buttonText;
    this.route = route;
    this.hiddenButton = hiddenButton;
  }
}
